<!--<div class="container app-tag-container">-->
<!--<app-tags></app-tags>-->
<!--</div>-->

<ng-container>
  <app-base-sub-category-slider></app-base-sub-category-slider>
  <div class="sortby">
    <div class="container">
      <div class="row">
        <div class="col-4 col-md-6">
          <button class="custom-btn btn-block  d-lg-none" (click)="mobileFilter = !mobileFilter">
            {{mobileFilter? language['close']: language['filter']}}
          </button>
        </div>
        <div class="sort col-8 col-md-6 text-right">
          <label>
            <select class="form-control"
              (change)="shopService.changeSort(sortOptions[$event.target.value].sort, sortOptions[$event.target.value].order)">
              <option *ngFor="let sort of sortOptions; let i = index;" [value]="i"
                [selected]="params['sort'] === sort.sort && params['order'] === sort.order">
                {{sort.name}}
              </option>
            </select>
            <i class="fa fa-angle-down" aria-hidden="true"></i>
          </label>
        </div>
      </div>
    </div>
  </div>
  <!--End Sort-->
  <div class="product-list" *ngIf="showProducts">
    <div class="container">
      <div class="sm-gutters row">
        <div [ngClass]="{'d-none': !mobileFilter}" class="col-lg-3 d-lg-block">
          <app-filter></app-filter>
        </div>
        <div [ngClass]="{'d-none': mobileFilter}" class="col-lg-9 d-lg-block">
          <div class="list" *ngIf="!loading">
            <div class="row sm-gutters" [@listAnimation]="products.length">
              <div *ngFor="let product of products" class="col-lg-4 col-md-6 product-container">
                <app-home-product [product]="product"></app-home-product>
              </div>
            </div>
            <ng-container *ngIf="pages_count.length > 1">
              <hr>
              <div class="site-navigation">
                <app-base-pagination></app-base-pagination>
              </div>
              <!--End site-navigation-->
            </ng-container>
          </div>
          <!--End Product-grid-->
        <div *ngIf="loading">
          <app-inner-loading></app-inner-loading>
        </div>
          <!--End collection__spinner-->
        </div>
        <!--End Col-->
      </div>
      <!--End Row-->
    </div>
    <!--End Container-->
  </div>
  <!--End Container-fluid-->
  <div class="container" *ngIf="!showProducts">
    <div class="empty-div">
      <p>
        {{language['noProductsAvaliable']}}
      </p>
    </div>
    <div class="text-center">
      <button (click)="backToPreviousCollection()" class="custom-btn">{{language['backToCollection']}}</button>
    </div>
  </div>
  <!--End Container-->
</ng-container>
